import React from "react";

import { Trans, useTranslation } from "react-i18next";
import { IoWarningOutline } from "react-icons/io5";

import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";

import env from "../../../../util/env";

import useStyles from "./styles";

type UploadErrorModalProps = {
  isOpen: boolean;
  uploadDataError?: string[];
  fileName?: string;
  onClose: () => void;
  onEditFile: () => void;
  textEditFile?: string;
  envDownloadTemplate?: string;
};

export const UploadErrorModal = ({
  isOpen,
  uploadDataError,
  fileName,
  onClose,
  onEditFile,
  textEditFile,
  envDownloadTemplate,
}: UploadErrorModalProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <ConfirmationModal
      open={isOpen}
      type="warning"
      leftIconTitle={<IoWarningOutline color="#F79009" />}
      closeModal={onClose}
      customColorCancel={Color.TEXT_INFO}
      submit={onEditFile}
      customColorSave={Color.WARNING}
      textSubmit={textEditFile ? translate(textEditFile) : translate("tryAgain2")}
      title={translate("errorsFoundInYourFile")}
      maxWidth="520px"
    >
      <main className={classes.container}>
        <p className={classes.fileNameParagrapher}>
          <Trans i18nKey="weFoundSomeIssuesInYourCSV" values={{ csvFileName: fileName || "" }} />
        </p>

        <section className={classes.sectionErrors}>
          {uploadDataError?.map((error) => (
            <span key={error}>{error}</span>
          ))}
        </section>

        <span className={classes.suggestionDownload}>
          {translate("needHelp")}{" "}
          <a
            className={classes.suggestionDownloadLink}
            href={envDownloadTemplate || env.LINK_TEMPLATES_ZIP}
            download
          >
            {translate("downloadOurTemplate")}
          </a>{" "}
          {translate("forTheCorrectFormat")}
        </span>
      </main>
    </ConfirmationModal>
  );
};
